/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Rule} from "../models/rule";
import {RulesService} from "../services/rules.service";
import { Input, Injectable } from "@angular/core";
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";

@Injectable()
@Input()
export class RulesResolver implements Resolve<Rule[]> {

  constructor(
    private mRuleService: RulesService
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<Rule[]> {
    try {
      return await this.mRuleService.getAllRules();
    } catch (error) {
      console.error("Problem resolving Rules... Error: " + error, error);
    }
  }

}
